import { ExternalArrow, Arrow } from 'app/media';
import classnames from 'classnames';
import styles from './link-button.module.scss';
import { Typography } from 'app/component-library-wave';

interface Props {
  url: string;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  iconRight?: 'arrowRight' | 'external';
  onClick?: () => void;
}

export const LinkButton = (props: Props) => (
  <a
    onClick={props.onClick}
    href={props.url}
    className={classnames(
      styles.linkStyledAsButton,
      props.variant === 'primary' ? styles.primary : '',
      props.className,
    )}
  >
    <Typography component="span" variant="formds-body" bold={true}>
      {props.children}
    </Typography>
    {props.iconRight === 'arrowRight' && <Arrow color="#fff" variant={'long'} direction={'right'} />}
    {(!props.iconRight || props.iconRight === 'external') && (
      <ExternalArrow className={props.variant === 'primary' ? styles.primaryIcon : styles.secondaryIcon} />
    )}
  </a>
);
